import { OnboardingLargeImage } from './OnboardingLargeImage';

const OnboardingTopicsLargeImage = ({ style }) => {
  const twoX = {
    es: require('./es/onboarding-topics@2x.jpg'),
    fr: require('./fr/onboarding-topics@2x.jpg'),
    en: require('./onboarding-topics@2x.jpg')
  };
  const threeX = {
    es: require('./es/onboarding-topics@3x.jpg'),
    fr: require('./fr/onboarding-topics@3x.jpg'),
    en: require('./onboarding-topics@3x.jpg')
  };
  return (
    <OnboardingLargeImage
      oneX={twoX}
      twoX={twoX}
      threeX={threeX}
      style={style}
    />
  );
};

export { OnboardingTopicsLargeImage };
